import { FileDown } from 'lucide-react';
import courseService from '../../../services/courseService';

const RevisionSheetBanner = ({ pdf, moduleId, language, locked }) => {
    const isStudyPlan = pdf.variant === 'studyplan';
    const label = isStudyPlan
        ? (language === 'fr' ? 'Plan de cours' : 'Study Plan')
        : (language === 'fr' ? 'Fiche de révision' : 'Review Sheet');
    const subtitle = isStudyPlan
        ? (language === 'fr' ? 'Téléchargez le plan de cours imprimable pour cette matière' : 'Download the printable study plan for this subject')
        : (language === 'fr' ? 'Téléchargez la fiche de révision imprimable pour cette matière' : 'Download the printable review sheet for this subject');

    const handleDownload = () => {
        if (locked) return;
        const url = courseService.getGroupPdfUrl(moduleId, pdf.groupName, language);
        window.open(url, '_blank');
    };

    return (
        <div
            className={`bg-gradient-to-r from-teal-50 to-cyan-50 dark:from-teal-500/10 dark:to-cyan-500/10 rounded-2xl p-4 md:p-6 border-2 border-dashed border-teal-300 dark:border-teal-500/30 flex flex-col md:flex-row md:items-center justify-between gap-4 md:gap-6 transition-all ${
                locked
                    ? 'opacity-50 grayscale pointer-events-none'
                    : 'hover:border-teal-400 dark:hover:border-teal-500/50 hover:shadow-md hover:shadow-teal-500/5'
            }`}
        >
            {/* Left: Icon + Text */}
            <div className="flex items-center gap-4 flex-1 min-w-0">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-teal-100 dark:bg-teal-500/20 flex items-center justify-center flex-shrink-0">
                    <FileDown className="w-6 h-6 md:w-7 md:h-7 text-teal-600 dark:text-teal-400" />
                </div>
                <div className="min-w-0">
                    <h4 className="text-base md:text-lg font-bold text-teal-800 dark:text-teal-300 tracking-tight flex items-center gap-3 flex-wrap">
                        {label}
                        <span className="px-2 py-0.5 rounded-md text-[9px] font-black uppercase tracking-wider bg-teal-500 text-white shadow-lg shadow-teal-500/30">
                            PDF
                        </span>
                    </h4>
                    <p className="text-xs text-teal-600/70 dark:text-teal-400/60 mt-0.5">
                        {subtitle}
                    </p>
                </div>
            </div>

            {/* Right: Download Button */}
            <div className="flex justify-center md:justify-end shrink-0">
                <button
                    onClick={handleDownload}
                    className="px-6 py-2.5 rounded-xl font-black text-xs text-white shadow-xl transition bg-gradient-to-r from-teal-500 to-cyan-600 hover:scale-105 active:scale-95 shadow-teal-500/20 flex items-center gap-2 justify-center whitespace-nowrap"
                >
                    <FileDown className="w-4 h-4" />
                    {language === 'fr' ? 'Télécharger' : 'Download'}
                </button>
            </div>
        </div>
    );
};

export default RevisionSheetBanner;
